import React, { useEffect, useState } from 'react';
import { FileDown } from 'lucide-react';
import { toast } from 'sonner';
import api from '../../lib/api';
import { Card, StatusPill, btnSmall, downloadFile, errorText, money } from './financeUi';

export const downloadStatement = (entry) =>
  downloadFile(`/financials/payouts/${entry.entry_id}/statement.pdf`, `statement-${entry.period}.pdf`)
    .then(() => toast.success('Statement downloaded'))
    .catch((err) => toast.error(errorText(err, 'Statement unavailable')));

export function PayoutStatementsCard() {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    api.request('/financials/statements/available').then(setRows).catch(() => setRows([]));
  }, []);
  if (!rows?.length) return null;
  return (
    <Card testid="payout-statements-card" title="Payout statements"
          aside={<span className="text-xs text-muted-foreground">{rows.length} approved</span>}>
      <ul className="divide-y">
        {rows.slice(0, 12).map((r) => (
          <li key={r.entry_id} className="flex items-center justify-between gap-3 px-5 py-3 text-sm"
              data-testid={`statement-row-${r.entry_id}`}>
            <div className="min-w-0">
              <p className="font-medium">{r.period} · {r.payee_name}</p>
              <p className="text-xs text-muted-foreground">{money(r.approved_amount)}</p>
            </div>
            <div className="flex items-center gap-2">
              <StatusPill value={r.status} />
              <button type="button" className={btnSmall} onClick={() => downloadStatement(r)}
                      data-testid={`download-statement-${r.entry_id}`}>
                <FileDown className="h-3.5 w-3.5" />Download Statement
              </button>
            </div>
          </li>
        ))}
      </ul>
    </Card>
  );
}
